"use strict";

require("core-js/modules/es.array.reduce.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT = exports.IS_DISABLED_OPTIONS = exports.INITIAL_VALUES = exports.FIELDS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TRANSLATION = {
  registeredSenior: 'Are you a Senior Citizen with ID?',
  yes: 'Yes',
  no: 'No',
  seniorCitizenId: 'Senior Citizen ID',
  seniorNoteHeader: 'Senior Citizens Discount',
  // eslint-disable-next-line max-len
  seniorNote: "Pursuant to R.A. No. 7432 as amended by R.A. 9257, An Act Granting Additional Benefits and Privileges to Senior Citizen, guests aged 60 and above holding a valid Senior Citizen ID is eligible for a 20% discount on the base fare for domestic flights. Senior citizen guests must present their Senior Citizen ID together with any VALID ID at the check-in counter for verification. Failure to do so may result in penalties of PHP1,500 plus the fare difference or denial of boarding.",
  requiredError: 'This field is required.',
  maxLengthError: 'Max allowed charater is {max}.'
};
exports.TRANSLATION = TRANSLATION;
var IS_DISABLED_OPTIONS = [{
  label: TRANSLATION.yes,
  value: 'true'
}, {
  label: TRANSLATION.no,
  value: 'false'
}];
exports.IS_DISABLED_OPTIONS = IS_DISABLED_OPTIONS;
var FIELDS = {
  isSenior: {
    label: TRANSLATION.registeredSenior,
    name: 'isSenior'
  },
  seniorCitizenId: {
    label: TRANSLATION.seniorCitizenId,
    name: 'seniorCitizenId'
  }
};
exports.FIELDS = FIELDS;

var INITIAL_VALUES = _objectSpread({}, Object.keys(FIELDS).reduce(function (acc, curr) {
  acc[curr] = '';
  return acc;
}, {}));

exports.INITIAL_VALUES = INITIAL_VALUES;
var TEXT = {
  COLOR: 'secondary',
  TYPE: 'sub'
};
exports.TEXT = TEXT;